const DOMAINS = {
    'domain-accomodation': 'beneficiary.accomodation',
    'domain-administration-terminology': 'authorization.administration-mean-terminology',
    'domain-admission-nature': 'authorization.admission-nature',
    'domain-admittance-regime': 'authorization.admittance-regime',
    'domain-authorization-form-status': 'authorization.authorization-form-status',
    'domain-chemotherapy-terminology': 'authorization.chemotherapy-terminology-type',
    'domain-consultation-types': 'authorization.consultation-types',
    'domain-contact-type': '@patient.contact.type',
    'domain-diagnosis-imaging': 'authorization.diagnosis-by-imaging-terminology',
    'domain-encounter-type': 'authorization.encounter-type',
    'domain-estado-civil': '@patient.family.status',
    'domain-form-type': 'authorization.form-type',
    'domain-functional-capacity': 'authorization.functional-capacity-terminology',
    'domain-gender': '@person.gender',
    'domain-hiring-type': 'authorization.hiring-type',
    'domain-manufacturer-option': 'authorization.manufacturer-option',
    'domain-measurement-terminology': 'authorization.measurement-unit-terminology',
    'domain-metastasis-terminology': 'authorization.metastasis-terminology',
    'domain-nodule-terminology': 'authorization.nodule-terminology',
    'domain-origin': 'beneficiary.origin',
    'domain-regulation': 'beneficiary.regulation',
    'domain-request-item-status': 'authorization.request-item-status',
    'domain-scope': 'beneficiary.scope',
    'domain-segmentation': 'beneficiary.support-segmentation',
    'domain-status-guia': 'authorization.form-status',
    'domain-surgery-nature': 'authorization.surgery-nature',
    'domain-treatment-purpose': 'authorization.treatment-purpose-terminology',
    'domain-tumor-staging': 'authorization.tumor-staging-terminology',
    'domain-tumor-terminology': 'authorization.tumor-terminology',
};
export default DOMAINS;
//# sourceMappingURL=domains.js.map